import { createContext, useContext } from 'react';
import type { ApiClient } from './client.js';

/**
 * The API client is handed down rather than imported as a module singleton, so a test can
 * mount a screen against a stub server without monkey-patching global `fetch`.
 */
export const ApiContext = createContext<ApiClient | null>(null);

export function useApiClient(): ApiClient {
  const client = useContext(ApiContext);
  if (!client) {
    throw new Error('useApiClient must be used inside <AppProviders>');
  }
  return client;
}
